function apiBaseUrl() {
  return process.env.REACT_APP_API_BASE_URL;
}

export function apiV2PurchaseOrders(withDraft=false) {
  if(withDraft) {
    return `${apiBaseUrl()}/api/v2/purchase_orders?with_draft_from=2019-02-19`;
  } else {
    return `${apiBaseUrl()}/api/v2/purchase_orders`;
  }
}

export function apiV2PurchaseOrder(id, userId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/purchase_orders/${id}`;
}

export function apiV2PurchaseOrderAttachments(id, userId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/purchase_orders/${id}/purchase_order_attachments`;
}

export function apiV2PurchaseOrderNotifications(id, userId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/purchase_orders/${id}/fca_notifications?fca_page=trade_document_show&last=true`;
}

export function apiV2PurchaseOrderResolveNotifications(id, userId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/purchase_orders/${id}/resolve_fca_notifications`;
}



// WEBPACK FOOTER //
// ./src/features/trade_documents/purchaseOrdersApiUrls.js